module.exports = __webpack_public_path__ + "static/media/tag.7ea580ec.svg";